var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-warehouse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8332 11.0832V4.87073C12.8332 4.3924 12.5415 3.96656 12.0982 3.78573L7.4315 1.91906C7.1515 1.80823 6.84234 1.80823 6.56234 1.91906L1.89567 3.78573C1.45817 3.96656 1.1665 4.39823 1.1665 4.87073V11.0832C1.1665 11.7249 1.6915 12.2499 2.33317 12.2499H4.08317V6.99989H9.9165V12.2499H11.6665C12.3082 12.2499 12.8332 11.7249 12.8332 11.0832ZM6.4165 11.0832H5.24984V12.2499H6.4165V11.0832ZM7.58317 9.33323H6.4165V10.4999H7.58317V9.33323ZM8.74984 11.0832H7.58317V12.2499H8.74984V11.0832Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.e4d1e45329606eddb275a77aab4af709.svg";
export { ForwardRef as ReactComponent };